import fetcher from '@/services/fetcher'
import { toPortalUrl } from '@/utils/url-generation-utils'
import { ref } from 'vue'

export function useCredit() {
  const errors = ref<string | null>(null)
  const isLoading = ref(false)

  /**
   * Charge credit for a draw.
   *
   * @param drawCode - The code of the draw.
   * @param ticketCount - The number of tickets to charge.
   * @param lockKey - Optional lock key for the transaction.
   * @returns A promise that resolves with the response data and error.
   */
  const chargeCredit = async (
    drawCode: string,
    ticketCount: number,
    lockKey?: string
  ) => {
    if (!drawCode || !ticketCount || !ticketCount) {
      errors.value = 'Invalid parameters provided'
      return { data: null, error: errors.value }
    }

    isLoading.value = true
    errors.value = null

    try {
      const { data: response, error } = await fetcher.post(
        toPortalUrl('/instantwin/charge_credit'),
        {
          drawCode,
          ticketCount,
          use_credit: true,
          lockKey: lockKey,
        }
      )

      if (error.value) {
        throw new Error(
          error.value.message || 'An error occurred while charging credit'
        )
      }

      isLoading.value = false
      return response.value
    } catch (e: any) {
      isLoading.value = false
      errors.value = e.message
      throw e
    }
  }

  return {
    chargeCredit,
    isLoading,
    errors,
  }
}
